import type React from 'react';

type Props = {
  data: Record<string, unknown>;
};

/**
 * Renders a JSON-LD block. Server-only by design — structured data has to be in the HTML the
 * crawler receives, not added after hydration.
 *
 * Every `<` is escaped to its unicode form. JSON only ever contains `<` inside string values, so a
 * blanket replace is safe, and it stops CMS text containing `</script>` from closing the tag early.
 */
const JsonLd: React.FC<Props> = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
  />
);

export { JsonLd };
